import {ErrorHandler, Inject, Injectable, Injector} from '@angular/core';
import {Store} from '@ngrx/store';
import {isOrderHistoryError, OrderHistoryError} from 'app/core/components/error-page/order-history-error';
import {ErrorActions} from 'app/core/components/error-page/state/error.actions';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(@Inject(Injector) private injector: Injector) {}

  handleError(error: Error): void {
    const store = this.injector.get(Store);
    const ohError = isOrderHistoryError(error) ? error : new OrderHistoryError({source: error});
    store.dispatch(ErrorActions.directToErrorPage({error: ohError}));
  }
}
